import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { IMG_CDN_URL } from '../../utils/links/link';
import Shimmer from '../../Shimmer/Shimmer';
import { AiFillStar } from 'react-icons/ai';
import "./Searched.css"
const Searched = () => {
    const[searchedData,setSearchedData]=useState({})
    const {id}=useParams();

 useEffect(()=>{
    getSearched();
 },[])
  
 async function getSearched(){
    const data=await fetch(`https://www.swiggy.com/dapi/restaurants/search/v3?lat=28.7040592&lng=77.10249019999999&str=${id}&trackingId=undefined&submitAction=ENTER&queryUniqueId=e1980339-6a22-b6dd-2839-c140c89dbf74`);
    const json=await data.json();
    setSearchedData(json?.data?.cards[1]?.groupedCard?.cardGroupMap?.RESTAURANT?.cards[0]?.card?.card?.info)
 }
 
  return ! searchedData ? (
   <Shimmer/>
  ) : (
    <div > 
      
         <Link to={"/rcard/"+searchedData.id} style={{textDecoration:"none"}} >
          <div className='Card'>
          <img className='cardImg' src={IMG_CDN_URL+searchedData.cloudinaryImageId}></img>
          <div className='headBinder'>
          <div className="cardTitle">{searchedData.name}</div>
          <div className='cardrate'>{searchedData.costForTwoMessage}</div>
          </div>
          <div className='cardInfo'>
                        <div className='Rating'>
                        <div className='Star'><AiFillStar/></div>
                        <div className='cardStar'>{searchedData.avgRating}</div>
                        </div>
                        <div className='cardMin'>{searchedData.slaString}</div>
                        <div className='cardrate'>{searchedData.costForTwoString}</div>
                        
                    </div>
          </div>
        
        </Link>
    </div>
  )
}

export default Searched